import Burger from './Burger';
import BurgerContainer from './Burger.container';
export default BurgerContainer(Burger);

//# sourceMappingURL=index.js.map